{/*import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/ApplicantsPage.css";
import {
  FiDownload,
  FiArrowLeft,
  FiFileText,
} from "react-icons/fi";
import { getRecruiterApplications } from "../services/jobsApi";

const ApplicantsPage = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();

  const [job, setJob] = useState(null);
  const [applicants, setApplicants] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  
  // old code 
  useEffect(() => {
    const storedJob = JSON.parse(
      localStorage.getItem("selectedJobForApplicants") || "null"
    );
    setJob(storedJob);

    const applicantsByJob = JSON.parse(
      localStorage.getItem("applicantsByJob") || "{}"
    );

    let list = applicantsByJob[jobId];

    if (!list || list.length === 0) {
      list = [
        {
          id: "a1",
          name: "John Doe",
          email: "john@example.com",
          phone: "+91 9876543210",
          experience: "3 Years",
          status: "Under review",
          appliedOn: "2025-02-01",
          resume: "/resumes/sample-resume.pdf",
          coverLetter:
            "I am very interested in this role and believe my skills align with your requirement...",
          notes: "",
        },
        {
          id: "a2",
          name: "Priya Sharma",
          email: "priya@example.com",
          phone: "+91 9876501234",
          experience: "2 Years",
          status: "Shortlisted",
          appliedOn: "2025-02-03",
          resume: "/resumes/sample-resume.pdf",
          coverLetter:
            "I am excited to apply for this role. My background in frontend development...",
          notes: "",
        },
      ];
    }

    setApplicants(list);
  }, [jobId]); 

  const [loading, setLoading] = useState(true);   // FIXE

  // Added on this 27-11-2025

  useEffect(() => {
    async function loadApplicants() {
      try {
        const data = await getRecruiterApplications();
        console.log("Applicants:", data);

        setApplicants(data);
      } catch (err) {
        console.error("Failed to fetch applications", err);
      } finally {
        setLoading(false);
      }
    }

    loadApplicants();
  }, []);

  if (loading) {
    return <div>Loading applicants...</div>;
  }

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };
  // old code
  {/*const handleStatusChange = (id, newStatus) => {
    const updated = applicants.map((a) =>
      a.id === id ? { ...a, status: newStatus } : a
    );
    setApplicants(updated);
    saveApplicants(updated);
  };
  const handleStatusChange = async (id, newStatus) => {
  try {
    // Update UI instantly
    const updated = applicants.map((a) =>
      a.id === id ? { ...a, status: newStatus } : a
    );
    setApplicants(updated);

    // Call backend API
    const token = localStorage.getItem("token");

    await fetch(
      `http://144.91.102.67:8001/api/applications/${id}/status?status=${newStatus}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("Status updated successfully");
  } catch (error) {
    console.error("Error updating status:", error);
    alert("Failed to update status");
  }
};

  const handleNotesChange = (id, value) => {
    const updated = applicants.map((a) =>
      a.id === id ? { ...a, notes: value } : a
    );
    setApplicants(updated);
    saveApplicants(updated);
  };

  const saveApplicants = (data) => {
    const store = JSON.parse(
      localStorage.getItem("applicantsByJob") || "{}"
    );
    store[jobId] = data;
    localStorage.setItem("applicantsByJob", JSON.stringify(store));
  };

  const exportToCSV = () => {
    if (!applicants?.length) return;

    const headers = [
      "Name",
      "Email",
      "Phone",
      "Experience",
      "Status",
      "Applied On",
    ];

    const rows = applicants.map((a) => [
      a.name,
      a.email,
      a.phone,
      a.experience,
      a.status,
      a.appliedOn,
    ]);

    const csv =
      [headers, ...rows].map((row) => row.join(",")).join("\n");

    const blob = new Blob([csv], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `applicants_job_${jobId}.csv`;
    link.click();
  };

  return (
    <div className="appl-container">
      <div className="appl-header">
        <div>
          <p className="breadcrumb">Dashboard / Applicants</p>
          <h2>Applicants</h2>
          {job && (
            <p className="job-subtitle">
              {job.jobTitle || job.title} · {job.location}
            </p>
          )}
        </div>

        <div className="header-actions">
          <button
            className="icon-btn"
            title="Export CSV"
            onClick={exportToCSV}
          >
            <FiDownload />
          </button>

          <button
            className="icon-btn"
            title="Back"
            onClick={() => navigate(-1)}
          >
            <FiArrowLeft />
          </button>
        </div>
      </div>

      <div className="appl-table-card">
        <table className="appl-table">
          <thead>
            <tr>
              <th>Candidate</th>
              <th>Email</th>
              <th>Experience</th>
              <th>Status</th>
              <th>Applied On</th>
            </tr>
          </thead>

          <tbody>
            {applicants.map((appl) => (
              <React.Fragment key={appl.id}>
                <tr
                  className="clickable-row"
                  onClick={() => toggleExpand(appl.id)}
                >
                  <td className="candidate-name">{appl.candidate?.full_name}</td>
                  <td>{appl.candidate?.email || "N/A"}</td>
                  <td>{appl.candidate?.experience || "N/A"}</td>
                  <td>
                    <select
                      className="status-dropdown"
                      value={appl.status}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) =>
                        handleStatusChange(appl.id, e.target.value)
                      }
                    >
                      <option>Under review</option>
                      <option>Interviewed</option>
                      <option>Offered</option>
                      <option>On hold</option>
                      <option>Rejected</option>
                      <option>Interview Scheduled</option>
                      <option>Offer Accepted</option>
                      <option>Offer Declined</option>
                      <option>In Process</option>
                      <option>Shortlisted</option>
                      <option>Assesment Selected</option>
                      <option>Hired</option>
                    </select>
                  </td>
                  <td>{appl.appliedAt || appl.applied_on || appl.applied_at}</td>
                </tr>

                {expandedId === appl.id && (
                  <tr className="expanded-row">
                    <td colSpan="5">
                      <div className="applicant-details-card">
                        <div className="details-grid">
                          {/*<div><strong>Name:</strong> {appl.candidate.full_name}</div>
                          <div><strong>Name:</strong> {appl.candidate?.full_name}</div>
                          <div><strong>Email:</strong> {appl.candidate?.email || "N/A"}</div>
                          <div><strong>Phone:</strong> {appl.candidate?.mobile || "N/A"}</div>
                          <div><strong>Experience:</strong> {appl.candidate?.experience || "N/A"}</div>
                        </div>

                        {/* Resume 
                        <div className="resume-section">
                          <div className="resume-header">
                            <p><strong>Resume</strong></p>
                            <a
                              href={appl.candidate?.resume_file}
                              download
                              target="_blank"
                              rel="noreferrer"
                              className="icon-btn"
                              title="Download Resume"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <FiDownload />
                            </a>
                          </div>

                          {/*<iframe
                            src={appl.resume}
                            title="Resume"
                            className="resume-viewer"
                          ></iframe>
                        </div>
                        <iframe
                            src={appl.candidate?.resume_file}
                            className="resume-viewer"
                          ></iframe>
                          </div>
                        {/* Cover Letter 
                        <div className="resume-section">
                          <p><strong>Cover Letter</strong></p>
                          <div className="cover-box">
                            {appl.coverLetter}
                          </div>
                        </div>

                        {/* Notes 
                        <div className="resume-section">
                          <p><strong>Recruiter Notes</strong></p>
                          <textarea
                            className="notes-box"
                            placeholder="Add private notes..."
                            value={appl.notes}
                            onChange={(e) =>
                              handleNotesChange(appl.id, e.target.value)
                            }
                          ></textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ApplicantsPage; */}

// added on 28-11-2025
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/ApplicantsPage.css";
import {
  FiDownload,
  FiArrowLeft,
  FiFileText,
} from "react-icons/fi";
import { getRecruiterApplications } from "../services/jobsApi";

const ApplicantsPage = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();

  const [Job, setJob] = useState(null);
  const [applicants, setApplicants] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadApplicants() {
      try {
        //const data = await getRecruiterApplications();
        const data = await getRecruiterApplications(jobId);
        console.log("Applicants:", data);

        setApplicants(data);
      } catch (err) {
        console.error("Failed to fetch applications", err);
      } finally {
        setLoading(false);
      }
    }

    loadApplicants();
  }, []);

  if (loading) return <div>Loading applicants...</div>;

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      const updated = applicants.map((a) =>
        a.id === id ? { ...a, status: newStatus } : a
      );
      setApplicants(updated);

      const token = localStorage.getItem("access_token");

      await fetch(
        `http://144.91.102.67:8002/api/applications/${id}/status?status=${newStatus}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          }
        },
      );
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to update status");
    }
  };

  const handleNotesChange = (id, value) => {
    const updated = applicants.map((a) =>
      a.id === id ? { ...a, notes: value } : a
    );
    setApplicants(updated);
    saveApplicants(updated);
  };

  const saveApplicants = (data) => {
    const store = JSON.parse(
      localStorage.getItem("applicantsByJob") || "{}"
    );
    store[jobId] = data;
    localStorage.setItem("applicantsByJob", JSON.stringify(store));
  };

  const exportToCSV = () => {
    if (!applicants?.length) return;

    const headers = [
      "Name",
      "Email",
      "Phone",
      "Experience",
      "Status",
      "Applied On",
    ];

    const rows = applicants.map((a) => [
      a.candidate.full_name,
      a.candidate.email,
      a.candidate.mobile,
      a.candidate.years_of_exp,
      a.status,
      a.applied_at,
    ]);

    const csv =
      [headers, ...rows].map((row) => row.join(",")).join("\n");

    const blob = new Blob([csv], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `applicants_job_${jobId}.csv`;
    link.click();
  };

  return (
    <div className="appl-container">
      <div className="appl-header">
        <div>
          <p className="breadcrumb">Dashboard / Applicants</p>
          <h2>Applicants</h2>

          {Job && (
            <p className="job-subtitle">
              {Job.jobTitle || Job.title} · {Job.location}
            </p>
          )}
        </div>

        <div className="header-actions">
          <button className="icon-btn" title="Export CSV" onClick={exportToCSV}>
            <FiDownload />
          </button>

          <button className="icon-btn" title="Back" onClick={() => navigate(-1)}>
            <FiArrowLeft />
          </button>
        </div>
      </div>

      <div className="appl-table-card">
        <table className="appl-table">
          <thead>
            <tr>
              <th>Candidate</th>
              <th>Email</th>
              <th>Experience</th>
              <th>Status</th>
              <th>Applied On</th>
            </tr>
          </thead>

          <tbody>
            {applicants.map((appl) => (
              <React.Fragment key={appl.id}>
                <tr
                  className="clickable-row"
                  onClick={() => toggleExpand(appl.id)}
                >
                  <td className="candidate-name">
                    {appl.candidate.full_name}
                  </td>

                  <td>{appl.candidate.email}</td>

                  <td>{appl.candidate.years_of_exp}</td>

                  <td>
                    <select
                      className="status-dropdown"
                      value={appl.status}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) =>
                        handleStatusChange(appl.id, e.target.value)
                      }
                    >
                      <option>Under review</option>
                      <option>Interviewed</option>
                      <option>Offered</option>
                      <option>On hold</option>
                      <option>Rejected</option>
                      <option>Interview Scheduled</option>
                      <option>Offer Accepted</option>
                      <option>Offer Declined</option>
                      <option>In Process</option>
                      <option>Shortlisted</option>
                      <option>Assesment Selected</option>
                      <option>Hired</option>
                    </select>
                  </td>

                  <td>{appl.applied_at}</td>
                </tr>

                {expandedId === appl.id && (
                  <tr className="expanded-row">
                    <td colSpan="5">
                      <div className="applicant-details-card">
                        <div className="details-grid">
                          <div><strong>Name:</strong> {appl.candidate.full_name}</div>
                          <div><strong>Email:</strong> {appl.candidate.email}</div>
                          <div><strong>Phone:</strong> {appl.candidate.mobile}</div>
                          <div><strong>Experience:</strong> {appl.candidate.years_of_exp}</div>
                        </div>

                        {/* Resume Section*/}
                        <div className="resume-section">
                          <div className="resume-header">
                            <p><strong>Resume</strong></p>
                            {appl.candidate.resume_file && (
                              <a
                                href={appl.candidate.resume_file}
                                download
                                target="_blank"
                                rel="noreferrer"
                                className="icon-btn"
                                title="Download Resume"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <FiDownload />
                              </a>
                            )}
                          </div>

                          {appl.candidate.resume_file ? (
                            <iframe
                              src={appl.candidate.resume_file}
                              title="Resume"
                              className="resume-viewer"
                            ></iframe>
                          ) : (
                            <p>No resume uploaded</p>
                          )}
                        </div>

                        {/* Notes Section */}
                        <div className="resume-section">
                          <p><strong>Recruiter Notes</strong></p>
                          <textarea
                            className="notes-box"
                            placeholder="Add private notes..."
                            value={appl.notes || ""}
                            onChange={(e) =>
                              handleNotesChange(appl.id, e.target.value)
                            }
                          ></textarea>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ApplicantsPage;

